/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

export interface AlertMessageParts {
  title: string;
  detail?: string;
}

// Most alerts read "What failed: why" (e.g. "Error saving configuration: column … violates …").
// Split at the first ": " into a bold title and a muted detail line; anything else is a title.
export const splitAlertMessage = (message: string): AlertMessageParts => {
  const index = message.indexOf(': ');
  if (index <= 0) return { title: message };
  const title = message.slice(0, index).trim();
  const detail = message.slice(index + 2).trim();
  return detail ? { title, detail } : { title };
};
